module.exports = __webpack_public_path__ + "assets/img/logo.ff148534.png";